import $ from 'jquery';
import $script from 'scriptjs';
import ProductDetails from '../components/ProductDetails';

export default class StaticProduct {
  constructor(section) {
    $script($('[data-scripts]').data('shopify-api-url'), () => {
      this.productDetails = new ProductDetails(section);
    });
  }

  onSectionUnload() {
    this.productDetails.unload();
  }
}
